<template>
  <div>
    <div class="top">缴费记录</div>
    <div class="contaa">
    
      <div v-if="datalist.length > 0" >
        <div v-for="item in datalist" :key="item.id" style="margin-bottom: 7px;">
          <van-cell
            :title="item.title"
            :label="item.validTime"
            class="single"
            ><span class="price">￥{{ item.totalFee }}</span></van-cell
          >
          <div class="mignxi"><span>缴费明细:</span></div>
          <div v-for="ele in item.orderItems" :key="ele.id" >
              <div class="one"><span>{{ele.itemName}}</span> <span class="oneprice">￥{{((ele.price)/100).toFixed(2)}}</span></div>
          </div>
          <div class="zhifut">
            <div class="left">
              <img src="../../assets/iconimg/suc.png" alt="" v-if="item.orderPayStatus==2" >
               <img src="../../assets/iconimg/err.png" alt="" v-else>
               <div class="spana">{{item.orderPayStatus==0?'待支付':item.orderPayStatus==2?'支付成功':item.orderPayStatus==50?'支付错误':item.orderPayStatus==42?'需要退款':item.orderPayStatus==41?'完成退款':item.orderPayStatus==43?'部分退款':item.orderPayStatus==40?'微信退款中':"订单取消"}}</div>
            </div>
            <!-- <van-button type="default" size="small" round >申请退款</van-button> -->
          </div>
        </div>
      </div>
      <div v-else>
        <van-empty description="暂无数据" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      datalist: [],
    };
  },

  mounted() {
    this.getdata();
  },

  methods: {
    getdata() {
      this.fetchget("/api/app/order/myList").then((res) => {
        if (res) {
          res.items.forEach((item) => {
            item.validTime = this.$moment(item.validTime).format(
              "YYYY-MM-DD HH:mm"
            );
            item.totalFee = (item.totalFee / 100).toFixed(2);
          });
          this.datalist = res.items;
        }
      });
    },
   
  },
};
</script>

<style lang="scss" scoped>
.top {
  width: 375px;
  height: 44px;
  background-color: #dd0000;
  height: 44px;
  text-align: center;
  font-family: MicrosoftYaHei;
  font-size: 17px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 44px;
  letter-spacing: 1px;
  color: #ffffff;
}

.contaa {
  overflow-y: auto;
  .single {
    color: #000000;
    font-size: 14px;
    font-weight: 600;
  }
  .price {
    color: #dd0000;
    font-size: 14px;
    font-weight: 600;
  }
  .one{
      background-color: #ffffff;
      line-height: 30px;
      color: #000000;
      font-size: 12px;
      padding: 0 20px;
      display: flex;
      justify-content: space-between;
      .oneprice{
        color: #a0a0a0;
      }
  }
  .mignxi{
      background-color: #ffffff;
      line-height: 40px;
      color: #000000;
      font-size: 14px;
      padding: 0 20px;
      font-weight: 600;
    //   border-bottom: 1px solid #eee;
    display: flex;
      justify-content: space-between;
      button{
        margin-top: 5px;
        width: 60px;
      }
  }
}
.zhifut{
  border-top:1px solid #eee;
  width: 335px;
	height: 60px;
  padding: 0 20px;
	background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  .left{
    
    img{
      padding-top:20px ;
      height: 20px;
      width: 20px;
      float: left;
    }
    .spana{
      padding-top:22px ;
      font-size: 12px;
      float: left;
      margin-left: 5px;
    }
  }
  button{
    margin-top:14px ;
  }
}
</style>